module.exports = __webpack_public_path__ + "img/icb-del-Adv-m@2x.d5c1cfde.png";